import { render, staticRenderFns } from "./subStockCodeField.vue?vue&type=template&id=638a1489&"
import script from "./subStockCodeField.vue?vue&type=script&lang=js&"
export * from "./subStockCodeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports